import {initializeApp} from 'firebase/app';
import {connectAuthEmulator, getAuth} from "firebase/auth";
import {getDatabase, connectDatabaseEmulator} from "firebase/database";
import {connectFunctionsEmulator, getFunctions} from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCT1DxvqYtBUZBrHudwA9K1SesnlMVlRZQ",
  authDomain: "clgmbh-trademaster4reseller.firebaseapp.com",
  databaseURL: "https://clgmbh-trademaster4reseller.firebaseio.com",
  projectId: "clgmbh-trademaster4reseller",
  storageBucket: "clgmbh-trademaster4reseller.appspot.com",
  messagingSenderId: "349448977251",
  appId: "1:349448977251:web:0fc48651f1b4d478933156",
  measurementId: "G-FD80HCHQ9F"
};

const firebase = initializeApp(firebaseConfig);
const auth = getAuth(firebase);
const db = getDatabase(firebase);
const functions = getFunctions(firebase);

if (location.hostname === 'localhost') {
  connectAuthEmulator(auth, 'http://localhost:9097');
  connectDatabaseEmulator(db, 'localhost', 9085);
  connectFunctionsEmulator(functions, 'localhost', 5003);
}

export {firebase, auth, db} 